import { CertificateNavigationItem } from '@app/layout/sidebar/models/certificate-navigation-item.model'
import { CertificateCategory } from '@app/shared/models/certificate-category.model'
import { enumValueFromRaw, OBJECT_TYPE } from '@features/certificate/models/certificate-select-options.model'

const isPresent = <T>(value: T | null | undefined): value is T => value !== null && value !== undefined
const padVersion = (version: number): string => String(version).padStart(2, '0')

/**
 * Builds the name shown for a certificate in the insured's certificate list:
 * - Lease aircraft: `[Registration]-[Number] [Draft]`
 * - Lease engine/equipment: `[Serial] [Number] [Draft]`
 * - All other categories: `[Number]-[Version] [Title] [Draft]`
 *
 * Version and draft version are optional and left out when unknown; the version
 * only appears once the certificate is past its first version.
 */
export function certificateListName(item: CertificateNavigationItem): string {
  const number = item.certificateIdValue?.certificateNumber
  const version = item.certificateIdValue?.certificateVersion
  const draftVersion = item.certificateIdValue?.certificateDraftVersion
  const draft = isPresent(draftVersion) ? padVersion(draftVersion) : null

  let parts: (string | null | undefined)[]
  if (item.certificateCategory === CertificateCategory.LEASE) {
    const objectType = enumValueFromRaw(OBJECT_TYPE, item.certificateObjectType)
    parts = objectType === OBJECT_TYPE.AIRCRAFT
      ? [[item.registrationNumber, number].filter(Boolean).join('-'), draft]
      : [item.serialNumber, number, draft]
  } else {
    const numberWithVersion = isPresent(number) && isPresent(version) && version > 1 ? `${number}-${padVersion(version)}` : number
    parts = [numberWithVersion, item.certificateTitle, draft]
  }

  const name = parts.filter(part => isPresent(part) && part !== '').join(' ')
  return name === '' ? (item.certificateTitle ?? 'Certificate') : name
}
